import React from "react";
import { Col, Input } from "antd";
import { FormItem } from "Components/form";
import { Controller } from "react-hook-form";

export default function JobForm({ form, readOnly = false, ...props }) {
  const { control, errors } = form;

  return (
    <Col xs={24} md={24} lg={12}>
      <FormItem label="Meslek">
        <Controller
          control={control}
          name="profession"
          as={<Input readOnly={readOnly} placeholder="Meslek giriniz" />}
        />
      </FormItem>
    </Col>
  );
}
